var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M3.333 7.239h3.674V3.905M13 7.24h.007M7 1.239h.007M1 7.239h.007m9.666 0H9.34m-2.333 6V9.905M1 9.905v1.334a2 2 0 0 0 2 2h1.333V9.905M9.667 1.24H11a2 2 0 0 1 2 2v1.333m-3.333 0v-.555M4.333 1.239H3a2 2 0 0 0-2 2v1.333h3.333zm5.334 8.666H13v1.334a2 2 0 0 1-2 2H9.667z"
  })));
};
export default SvgQrCode;